import { gql } from '@apollo/client';

export const LINKS_BY_COMMODITY = gql`
  query LinkByCommodity($linkCommodityInput: LinkCommodityInput!) {
    linkByCommodity(linkCommodityInput: $linkCommodityInput) {
      id
      commType
      linkedCommType
      tag: linkedTag
      commodityTag: tag
    }
  }
`;

export const SAVE_LINKS = gql`
  mutation SaveLink($saveLinkInput: SaveLinkInput!) {
    saveLink(saveLinkInput: $saveLinkInput) {
      links {
        id
        commType
        linkedCommType
        tag: linkedTag
        commodityTag: tag
      }
      infos
      errors
    }
  }
`;
